<template>
  <div v-once class="not-found">
    <Polygons404 v-once />
  </div>
</template>

<script>
import Polygons404 from './components/Polygons404'

export default {
  components: {
    Polygons404
  }
}
</script>

<style lang="stylus" scoped>
.not-found {
  height 100vh
  overflow auto
}
</style>
